'use strict';

import {isDev, threeJsVariables} from "../../settings";
import * as dat from "dat.gui";
import { ColorCorrection } from '../threejs/colorCorrection';

/**
 * GUI - helper for visual options for object on Scene
 * Works only in development mode
 */

export const addGui = () => {
    if (!isDev) return;

    console.log('GUI Development mode activated');

    threeJsVariables.gui = new dat.GUI();
    threeJsVariables.gui.close();

    new ColorCorrection().debug();

    // threeJsVariables.gui = gui;
}